import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Santéclair screen — shares the View frame with the real content. */
export function SanteclairPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={160} height={32} />
        </View.Header>
        <View.Body>
          <Skeleton variant="text" width={240} height={24} />
          <Skeleton variant="block" height={328} />
          <Skeleton variant="text" width={200} height={24} />
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
